import React from 'react';
import {
  serverPath,
  //  colorMappings,
  getUserImage,
} from '../../utils';
import {
  Icon,
  Button,
  Dropdown,
  Image,
  SemanticSIZES,
  Message,
} from 'semantic-ui-react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { LoginModal } from '../Modal/LoginModal';
import axios from 'axios';
// import { SubscribeButton } from '../SubscribeButton/SubscribeButton';
import { ProfileModal } from '../Modal/ProfileModal';
import Announce from '../Announce/Announce';
// import { InviteButton } from '../InviteButton/InviteButton';
// import appStyles from '../App/App.module.css';
// import { Hero } from '../Home/Home';
import { createNewRoom } from '../../api/room';
import InvitePeople from '../InvitePeople/InvitePeople';
import { Socket } from 'socket.io-client';
import { endParty } from '../../api/user';

export async function createRoom(
  user: firebase.User | undefined,
  openNewTab: boolean | undefined,
  video: string = ''
) {
  const uid = user?.uid!;
  const data = (await createNewRoom({ uid, video })).data;

  if (openNewTab) {
    window.open('/watch' + data.name);
  } else {
    window.location.assign('/watch' + data.name);
  }
}

type Props = {
  user: firebase.User | undefined;
  size?: SemanticSIZES;
  openNewTab?: boolean;
};

export class NewRoomButton extends React.Component<
  Props,
  { errorMessage: string }
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      errorMessage: '',
    };
  }

  createRoom = async () => {
    try {
      await createRoom(this.props.user, this.props.openNewTab);
    } catch (error) {
      this.setState({ errorMessage: 'Error while creating room' });
    }
  };
  render() {
    return (
      <>
        {this.state.errorMessage ? (
          <Message
            negative
            header="Error"
            content={this.state.errorMessage}
            className="fixed bottom-[10px] right-[10px] z-[999]"
          ></Message>
        ) : (
          <Button
            color="blue"
            size={this.props.size}
            icon
            labelPosition="left"
            onClick={this.createRoom}
            className={`buttonsvg ${this.props.size ? '' : 'toolButton'}`}
            fluid
          >
            {/* <Icon name="certificate" /> */}
            <img src="/emojione-monotone_party-popper.svg" alt="" />
            Watch Party
          </Button>
        )}
      </>
    );
  }
}

type SignInButtonProps = {
  user: firebase.User | undefined;
  fluid?: boolean;
  isSubscriber: boolean;
};

export class SignInButton extends React.Component<SignInButtonProps> {
  public state = {
    isLoginOpen: false,
    isProfileOpen: false,
    userImage: null,
  };

  async componentDidUpdate(prevProps: SignInButtonProps) {
    if (!prevProps.user && this.props.user) {
      this.setState({ userImage: await getUserImage(this.props.user) });
    }
  }

  facebookSignIn = async () => {
    const provider = new firebase.auth.FacebookAuthProvider();
    await firebase.auth().signInWithPopup(provider);
  };

  googleSignIn = async () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    await firebase.auth().signInWithPopup(provider);
  };

  signOut = () => {
    firebase.auth().signOut();
    window.location.reload();
  };

  render() {
    if (this.props.user) {
      return (
        <div className="m-1 w-full items-center cursor-pointer">
          <Image
            avatar
            src={this.state.userImage}
            onClick={() => this.setState({ isProfileOpen: true })}
          />
          {this.state.isProfileOpen && this.props.user && (
            <ProfileModal
              user={this.props.user}
              userImage={this.state.userImage}
              close={() => this.setState({ isProfileOpen: false })}
              isSubscriber={this.props.isSubscriber}
            />
          )}
        </div>
      );
    }
    return (
      <React.Fragment>
        {this.state.isLoginOpen && (
          <LoginModal
            closeModal={() => this.setState({ isLoginOpen: false })}
          />
        )}
        {/* <Popup
          basic
          content="Sign in to set your name and picture, subscribe, or launch VBrowsers"
          trigger={
            <Dropdown
              style={{ height: '36px' }}
              icon="sign in"
              labeled
              className="icon"
              button
              text="Sign in"
              fluid={this.props.fluid}
            >
              <Dropdown.Menu>
                <Dropdown.Item onClick={this.facebookSignIn}>
                  <Icon name="facebook" />
                  Facebook
                </Dropdown.Item>
                <Dropdown.Item onClick={this.googleSignIn}>
                  <Icon name="google" />
                  Google
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => this.setState({ isLoginOpen: true })}
                >
                  <Icon name="mail" />
                  Email
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          }
        /> */}
      </React.Fragment>
    );
  }
}

export class ListRoomsButton extends React.Component<{
  user: firebase.User | undefined;
}> {
  public state = { rooms: [] as PersistentRoom[] };

  componentDidMount() {
    this.refreshRooms();
  }

  refreshRooms = async () => {
    if (this.props.user) {
      const token = await this.props.user.getIdToken();
      const response = await axios.get(
        serverPath + `/listRooms?uid=${this.props.user?.uid}&token=${token}`
      );
      this.setState({ rooms: response.data });
    }
  };

  deleteRoom = async (roomId: string) => {
    if (this.props.user) {
      const token = await this.props.user.getIdToken();
      await axios.delete(
        serverPath +
          `/deleteRoom?uid=${this.props.user?.uid}&token=${token}&roomId=${roomId}`
      );
      this.setState({
        rooms: this.state.rooms.filter((room) => room.roomId !== roomId),
      });
      this.refreshRooms();
    }
  };

  render() {
    return (
      <Dropdown
        icon="group"
        labeled
        className="icon h-9"
        button
        text="My Rooms"
        onClick={this.refreshRooms}
        scrolling
        pointing="top right"
      >
        <Dropdown.Menu>
          {this.state.rooms.length === 0 && (
            <Dropdown.Item disabled>You have no permanent rooms.</Dropdown.Item>
          )}
          {this.state.rooms.map((room: any) => {
            return (
              <Dropdown.Item
                key={room.roomId}
                link="true"
                href={
                  room.vanity ? '/r/' + room.vanity : '/watch' + room.roomId
                }
              >
                <div className="flex items-center">
                  {room.vanity ? `/r/${room.vanity}` : room.roomId}
                  <div className="ml-auto pl-5">
                    <Button
                      icon
                      onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        e.preventDefault();
                        this.deleteRoom(room.roomId);
                      }}
                      color="red"
                      size="mini"
                    >
                      <Icon name="trash" />
                    </Button>
                  </div>
                </div>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export class TopBar extends React.Component<{
  user?: firebase.User | User;
  hideNewRoom?: boolean;
  hideSignin?: boolean;
  hideMyRooms?: boolean;
  isSubscriber: boolean;
  roomTitle?: string;
  roomDescription?: string;
  roomTitleColor?: string;
  showInviteButton?: boolean;
  roomId: string;
  owner: string | undefined;
  watchPartyDetails: IWatchpartyDetails | undefined;
  participants: User[];
  handleClickOnNo: () => void;
  socket: Socket;
  coHosts: string[];
  showAdminLeaveModal: boolean;
  handleToggleAdminLeaveModal: () => void;
  handleToggleLeaveModal: () => void;
  isHostorCohost: boolean;
}> {
  public state = {
    isInvitePeopleSheetOpen: false,
    copied: false,
    showModal: false,
    showAdminLeaveModal: false,
  };

  handleCopyInviteLink = () => {
    navigator.clipboard.writeText(window.location.href); // or your custom link
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };
  handleRedirect = (getLink: string) => {
    window.open(getLink, '_blank', 'noopener');
  };

  redirectToWatchPartyDomain = () => {
    if (process.env.REACT_APP_DMDB_DOMAIN) {
      window.location.href = process.env.REACT_APP_DMDB_DOMAIN;
    } else {
      window.location.href = 'https://www.dmdb.com';
    }
  };

  render() {
    return (
      <div className="flex justify-between p-5 items-center">
        <div>
          <a href="/" className="inline-block">
            <img alt="hero" className="w-40 object-contain" src={'/logo.png'} />
          </a>
        </div>
        <Announce />
        <div className="flex items-center justify-end gap-2">
          <button
            className="gradient-btn text-black flex items-center gap-1 rounded-lg py-2 px-4 text-[18px] duration-200  hover:opacity-70"
            onClick={() => {
              this.setState({ isInvitePeopleSheetOpen: true });
            }}
          >
            <i className="ri-user-add-fill"></i>
            <span className="max-sm:hidden">Invite People</span>
          </button>

          <div className="relative group">
            <button
              onClick={() => {
                this.setState({ showModal: !this.state.showModal });
              }}
              className="gradient-btn text-black flex items-center gap-1 rounded-lg py-2 px-4 text-[18px] duration-200  hover:opacity-70"
            >
              <i className="ri-share-fill"></i>
              <span className="max-sm:hidden">Share Link</span>
            </button>
            {/* {this.state.showModal && ()} */}
            <div className="absolute max-sm:right-0 overflow-hidden z-30 p-[1px] after:content-[''] after:absolute after:inset-0 after:rounded-lg after:p-[5px] after:pointer-events-none after:z-0 gradient-pink-border hidden group-hover:block">
              <div className="relative z-[1] overflow-hidden bg-[#040404] rounded-lg flex flex-col gap-1 p-1.5">
                <button
                  className="w-full share-group rounded-md flex items-center gap-1 text-[16px] p-2 hover:bg-gradient-to-tr hover:from-[#7b55fe] hover:via-[#da7aff] hover:to-[#ff26e6]"
                  onClick={() => {
                    this.handleRedirect(
                      `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&t=${this.props.watchPartyDetails?.title}`
                    );
                  }}
                >
                  <svg
                    className="fill-[#9558F9]"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill=""
                    stroke="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22 16.19C22 19.83 19.83 22 16.19 22H15C14.45 22 14 21.55 14 21V15.23C14 14.96 14.22 14.73 14.49 14.73L16.25 14.7C16.39 14.69 16.51 14.59 16.54 14.45L16.89 12.54C16.92 12.36 16.78 12.19 16.59 12.19L14.46 12.22C14.18 12.22 13.96 12 13.95 11.73L13.91 9.28C13.91 9.12 14.04 8.98001 14.21 8.98001L16.61 8.94C16.78 8.94 16.91 8.81001 16.91 8.64001L16.87 6.23999C16.87 6.06999 16.74 5.94 16.57 5.94L13.87 5.98001C12.21 6.01001 10.89 7.37 10.92 9.03L10.97 11.78C10.98 12.06 10.76 12.28 10.48 12.29L9.28 12.31C9.11 12.31 8.98001 12.44 8.98001 12.61L9.01001 14.51C9.01001 14.68 9.14 14.81 9.31 14.81L10.51 14.79C10.79 14.79 11.01 15.01 11.02 15.28L11.11 20.98C11.12 21.54 10.67 22 10.11 22H7.81C4.17 22 2 19.83 2 16.18V7.81C2 4.17 4.17 2 7.81 2H16.19C19.83 2 22 4.17 22 7.81V16.19V16.19Z"
                      fill=""
                      stroke="none"
                    ></path>
                  </svg>
                  <span className="text-gradient-pink">Facebook</span>
                </button>
                <button
                  className="w-full share-group rounded-md flex items-center gap-1 text-[16px] p-2 hover:bg-gradient-to-tr hover:from-[#7b55fe] hover:via-[#da7aff] hover:to-[#ff26e6]"
                  onClick={() => {
                    this.handleRedirect(
                      `https://api.whatsapp.com/send?text=${window.location.href}`
                    );
                  }}
                >
                  <svg
                    className="fill-[#9558F9]"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill=""
                    stroke="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.8 2C4.14903 2 2 4.14903 2 6.8V17.2C2 19.851 4.14903 22 6.8 22H17.2C19.851 22 22 19.851 22 17.2V6.8C22 4.14903 19.851 2 17.2 2H6.8ZM10.983 6.08426C14.6246 5.48434 17.7862 8.16598 17.9901 11.6455C18.1881 15.0171 15.3805 17.9987 11.9969 17.9987C10.8871 17.9987 9.84919 17.6987 8.96131 17.1768L7.00555 17.7167C6.56161 17.8427 6.14768 17.4348 6.26766 16.9848L6.8016 14.9991C6.14769 13.8652 5.84771 12.4914 6.07568 11.0396C6.46563 8.53193 8.47537 6.49821 10.983 6.08426ZM14.7266 14.5372C14.8105 14.4412 14.8765 14.3392 14.9305 14.2312C14.9605 14.1638 14.9811 14.0942 15.0011 14.0265C15.0131 13.9857 15.025 13.9456 15.0385 13.9072C15.0385 13.8232 15.0205 13.7513 14.9905 13.6733C14.9545 13.6013 14.9005 13.5353 14.8226 13.4813L13.8267 12.7734C13.7547 12.7194 13.6827 12.6834 13.6167 12.6534C13.5507 12.6234 13.4907 12.6114 13.4307 12.6114C13.3527 12.6114 13.2868 12.6354 13.2148 12.6774C13.1488 12.7134 13.0768 12.7674 12.9988 12.8454L12.7708 13.0734C12.7348 13.1093 12.6988 13.1273 12.6448 13.1273C12.6148 13.1273 12.5908 13.1273 12.5668 13.1153C12.5578 13.1123 12.5488 13.1078 12.5398 13.1033C12.5308 13.0988 12.5218 13.0943 12.5128 13.0913C12.4108 13.0374 12.2789 12.9474 12.1229 12.8154C11.9609 12.6774 11.805 12.5334 11.643 12.3714C11.487 12.2155 11.343 12.0535 11.205 11.8975C11.073 11.7415 10.9771 11.6155 10.9231 11.5135C10.9171 11.4956 10.911 11.4776 10.899 11.4536C10.893 11.4296 10.8871 11.4056 10.8871 11.3816C10.8871 11.3336 10.899 11.2976 10.935 11.2616L11.163 11.0216C11.235 10.9496 11.289 10.8776 11.331 10.8056C11.373 10.7337 11.397 10.6617 11.397 10.5897C11.397 10.5297 11.385 10.4697 11.355 10.4037C11.331 10.3377 11.289 10.2717 11.235 10.1937L10.5391 9.20985C10.4851 9.13186 10.4131 9.07787 10.3351 9.04187C10.2571 9.00588 10.1732 8.98788 10.0892 8.98788C9.86719 8.98788 9.65723 9.07787 9.46526 9.26985C9.30328 9.41983 9.18928 9.5878 9.11729 9.77378C9.0453 9.95375 9.00931 10.1517 9.00931 10.3557C9.00931 10.6677 9.08129 10.9976 9.22527 11.3396C9.36926 11.6815 9.56722 12.0235 9.81319 12.3654C10.0652 12.7074 10.3411 13.0374 10.6531 13.3493C10.9651 13.6553 11.289 13.9372 11.637 14.1892C11.9789 14.4352 12.3209 14.6332 12.6688 14.7831C13.0108 14.9331 13.3407 15.0051 13.6467 15.0051C13.8567 15.0051 14.0546 14.9691 14.2346 14.8911C14.4146 14.8191 14.5766 14.6991 14.7266 14.5372Z"
                      fill=""
                      stroke="none"
                    ></path>
                  </svg>
                  <span className="text-gradient-pink">Whatsapp</span>
                </button>
                <button
                  className="w-full share-group rounded-md flex items-center gap-1 text-[16px] p-2 hover:bg-gradient-to-tr hover:from-[#7b55fe] hover:via-[#da7aff] hover:to-[#ff26e6]"
                  onClick={() => {
                    this.handleRedirect(
                      `https://twitter.com/share?text=${this.props.watchPartyDetails?.title} via @DMDB-Watchparty &amp;url=${window.location.href}`
                    );
                  }}
                >
                  <svg
                    className="fill-[#9558F9]"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill=""
                    stroke="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.4 2C4.41766 2 2 4.41766 2 7.4V16.6C2 19.5823 4.41766 22 7.4 22H16.6C19.5823 22 22 19.5823 22 16.6V7.4C22 4.41766 19.5823 2 16.6 2H7.4ZM10.4393 12.1702L5.03407 5H9.2L12.7436 9.70068L17.1292 5H18.3534L13.2905 10.4265L19 18H14.8341L10.9865 12.8958L6.22427 18H5L10.4393 12.1702ZM8.74821 5.89459H6.8344L15.2856 17.1054H17.1994L8.74821 5.89459Z"
                      fill=""
                      stroke="none"
                    ></path>
                  </svg>
                  <span className="text-gradient-pink">X</span>
                </button>
                <button
                  className="w-full share-group rounded-md flex items-center gap-1 text-[16px] p-2 hover:bg-gradient-to-tr hover:from-[#7b55fe] hover:via-[#da7aff] hover:to-[#ff26e6]"
                  onClick={() => {
                    this.handleRedirect(
                      `mailto:?subject=${encodeURIComponent(
                        'Watchparty - ' +
                          (this.props.watchPartyDetails?.title ?? '')
                      )}&body=${encodeURIComponent(
                        `Hello,\n\nYou've been invited to join the Watchparty.\nOpen the link to join the party:\n${window.location.href}`
                      )}`
                    );
                  }}
                >
                  <svg
                    className="fill-[#9558F9]"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill=""
                    stroke="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.8 2C4.14903 2 2 4.14903 2 6.8V17.2C2 19.851 4.14903 22 6.8 22H17.2C19.851 22 22 19.851 22 17.2V6.8C22 4.14903 19.851 2 17.2 2H6.8ZM9.5 8H14.5C16 8 17 8.75 17 10.5V14C17 15.75 16 16.5 14.5 16.5H9.5C8 16.5 7 15.75 7 14V10.5C7 8.75 8 8 9.5 8ZM13.17 12.295L14.735 11.045C14.895 10.915 14.92 10.675 14.79 10.515C14.665 10.35 14.425 10.325 14.265 10.455L12.7 11.705C12.32 12.01 11.675 12.01 11.295 11.705L9.73 10.455C9.57 10.325 9.335 10.355 9.205 10.515C9.08 10.675 9.105 10.915 9.265 11.045L10.83 12.295C11.155 12.56 11.58 12.69 12 12.69C12.42 12.69 12.84 12.56 13.17 12.295Z"
                      fill=""
                      stroke="none"
                    ></path>
                  </svg>
                  <span className="text-gradient-pink">Mail</span>
                </button>
                <button
                  className="w-full share-group rounded-md flex items-center gap-1 text-[16px] p-2 hover:bg-gradient-to-tr hover:from-[#7b55fe] hover:via-[#da7aff] hover:to-[#ff26e6]"
                  onClick={() => {
                    this.handleRedirect(
                      `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${this.props.watchPartyDetails?.title}`
                    );
                  }}
                >
                  <svg
                    className="fill-[#9558F9]"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill=""
                    stroke="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.8 2C4.14903 2 2 4.14903 2 6.8V17.2C2 19.851 4.14903 22 6.8 22H17.2C19.851 22 22 19.851 22 17.2V6.8C22 4.14903 19.851 2 17.2 2H6.8ZM7.2168 16.3465H8.95593V9.82473H7.2168V16.3465ZM7.2168 7.65082C7.2168 8.13125 7.60593 8.52038 8.08636 8.52038C8.5668 8.52038 8.95593 8.13125 8.95593 7.65082C8.95593 7.17038 8.5668 6.78125 8.08636 6.78125C7.60593 6.78125 7.2168 7.17038 7.2168 7.65082ZM15.4777 16.3465H17.2168V12.6508C17.2168 11.0899 15.9516 9.82473 14.3907 9.82473C13.6307 9.82473 12.942 10.1265 12.4342 10.6143V9.82473H10.6951V16.3465H12.4342V13.0856C12.4342 12.2486 13.119 11.5639 13.9559 11.5639C14.7929 11.5639 15.4777 12.2486 15.4777 13.0856V14.1726V16.3465Z"
                      fill=""
                      stroke="none"
                    ></path>
                  </svg>
                  <span className="text-gradient-pink">Linkedin</span>
                </button>
                {this.props.showInviteButton && (
                  <button
                    className="w-full share-group rounded-md flex items-center gap-1 text-[16px] p-2 hover:bg-gradient-to-tr hover:from-[#7b55fe] hover:via-[#da7aff] hover:to-[#ff26e6]"
                    onClick={() => this.handleCopyInviteLink()}
                  >
                    {this.state.copied ? (
                      <i className="ri-check-line text-[23px] text-[#9558F9]"></i>
                    ) : (
                      <i className="ri-file-copy-fill text-[23px] text-[#9558F9]"></i>
                    )}
                    <span className="text-gradient-pink">
                      {this.state.copied ? 'Copied' : 'Copy Link'}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
          <button
            className="gradient-btn text-black flex items-center gap-1 rounded-lg py-2 px-4 text-[18px] duration-200  hover:opacity-70"
            onClick={async () => {
              if (this.props.isHostorCohost) {
                if (
                  Array.from(
                    new Set(this.props.participants.map((p) => p.uid))
                  ).map((uniqueUid) => {
                    return this.props.participants.find(
                      (i) => i.uid === uniqueUid
                    );
                  }).length !== 1
                ) {
                  this.props.handleToggleAdminLeaveModal();
                } else {
                  this.props.handleToggleLeaveModal();
                }
              } else {
                this.props.handleToggleLeaveModal();
              }
            }}
          >
            <i className="ri-logout-box-r-fill"></i>
            <span className="max-sm:hidden">
              {this.props.isHostorCohost ? 'End' : 'Leave'} Watch Party
            </span>
          </button>
          {/* {this.props.showInviteButton && (
            <button
              className="gradient-btn text-black flex items-center gap-1 rounded-lg py-2 px-4 text-[18px] relative duration-200  hover:opacity-70"
              onClick={() => this.handleCopyInviteLink()}
            >
              <i className="ri-file-copy-fill"></i>
              <span className="max-sm:hidden">Copy Party Link</span>
              {this.state.copied && (
                <div className="absolute left-1/2 -translate-x-1/2 mt-2 px-4 py-2 bg-white -bottom-8 text-black text-sm rounded-md shadow-lg z-10">
                  Copied!
                </div>
              )}
            </button>
          )} */}
          {/* {this.props.showInviteButton && <InviteButton />}
            {!this.props.hideNewRoom && (
              <NewRoomButton user={this.props.user} openNewTab />
            )}
            {!this.props.hideMyRooms && this.props.user && (
              <ListRoomsButton user={this.props.user} />
            )} */}
          {/* {subscribeButton}
            {!this.props.hideSignin && (
              <SignInButton
                user={this.props.user}
                isSubscriber={this.props.isSubscriber}
              />
            )} */}

          {this.state.isInvitePeopleSheetOpen && (
            <InvitePeople
              roomId={this.props.roomId}
              open={this.state.isInvitePeopleSheetOpen}
              setOpen={() => {
                this.setState({
                  isInvitePeopleSheetOpen: !this.state.isInvitePeopleSheetOpen,
                });
              }}
            />
          )}
        </div>
      </div>
    );
  }
}
